import { Box, Stack, Typography } from '@mui/material';
import IconButton from 'components/IconButton';
import Overlay from 'components/Overlay';
import React, { useContext } from 'react';
import { getItemImage } from 'utils/item';
import { modifierContext } from '../ModifierProvider';

function Header({ item, isCollapsed }) {
  const { handleBack, parent } = useContext(modifierContext);
  const image = getItemImage(item, 'lg');
  if (!isCollapsed && image) {
    return null
  }
  return (
    <Box
      sx={{
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <Overlay.Header showClose={!parent || isCollapsed}>
        <Stack sx={{ opacity: (isCollapsed ||!image) ? 1 : 0, transition: 'opacity 0.5s', }}>
          {!parent && (
            <Typography variant="title-md" sx={{ textWrap: 'wrap' }}>
              {item.name}
            </Typography>
          )}
          {parent && (
            <Stack  direction="row" alignItems="center">
              <IconButton name="arrow-withtale-left" onClick={handleBack} sx={{ backgroundColor: 'unset' }}/>
              <Stack>

                <Typography variant="title-md" sx={{ textWrap: 'wrap' }}>
                  {parent.option.title}
                </Typography>
                <Typography variant="body-caption" sx={{ textWrap: 'wrap' }}>
                  {item.name}
                </Typography>
              </Stack>

            </Stack>
          )}
        </Stack>
      </Overlay.Header>
    </Box>
  );
}

export default Header;
